module.exports = __webpack_public_path__ + "b04d9b1ea9d981b8fd2c07dce7dc16d3.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./docs/karte_festival.jpg
// module id = 737
// module chunks = 0